import React from "react";
// import { CirclePlus } from "lucide-react";
// import { Link } from "react-router-dom";
import PostListView from "./PostListView";

export default function Page() {
  // const [searchPostsTerm, setSearchPostsTerm] = useState("");

  return (
    <main className="p-6 w-100 d-flex flex-column gap-6">
      <PostListView/>
    </main>
  );
}